module.exports = __webpack_public_path__ + "08ed89e9887c9c6cd334779f184ca3e7.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/video/barn_fr.mp4
// module id = 938
// module chunks = 4